import { getActiveDates } from './activeDates';
import { ActivityState as ImportedActivityState, getActivityState } from './activityState';
import { LifeCycle as ImportedLifeCycle, State as ImportedState } from './lifeCycle';

export type ActivityState = ImportedActivityState;
export type LifeCycle = ImportedLifeCycle;
export type State = ImportedState;

export const Helpers = {
  getActiveDates,
  getActivityState,
};
